import React, { useEffect, useState } from 'react';
import { AnchorSpan, ContainerDiv } from '../styledComponent/StyledComponent';
import { Col, Row } from '../flexbox/Flex';
import { BaseTable, Button, FormField, Modal, Select, TextInput, Option, SingleDatePicker, Toggle, Label, SinglePickerValueType, TextTypes } from '@sede-enterprise/shell-ds-react-framework';
import { Add, Search } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import './styles.css'
import { postData } from '../../services/ApiService';
import { ApiUrls } from '../../helpers/ApiUrls';
import ResponseErrorModal from '../responseErrorModal/ResponseErrorModal';
import { useToast } from 'rc-toastr'
import Loader from '../loader/Loader';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';
import StatusCell from '../common/StatusCell';
interface country  {
    id?:string;
    name : string;
    startDate : SinglePickerValueType | null;
    endDate : SinglePickerValueType | null;
    isActive : boolean;
    isLocal : boolean;
}


const Country = (props: any) => {
    const [openModal, setOpenModal] = useState(false);
    const [modelTitle, setModelTitle] = useState('');
    const { toast } = useToast();
    const [searchText, setSearchText] = useState('');

    const [isOnLoad, setIsOnLoad] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [countryDeatils, setCountryDeatils] = useState<country>({
        id: '',
        name : '',
        startDate : null,
        endDate : null,
        isActive : false,
        isLocal : false
    });
    const [countriesList, setCountriesList ] = useState<{countryId: string, countryName: string}[]>([]);
    const [miCountries, setMiCountires] = useState<country[]>([]);

    const [apiErrorResponse, setApiErrorResponse] = useState<APIErrorResponseInterface | null>();
    const columns: ColumnDef<country>[] = [{
        header: 'Country',
        accessorKey: 'name',
        size: 60
    }, {
        header: 'Start Date',
        accessorKey: 'startDate',
        cell: ({row}) =>{
            return(
                dayjs(row.original.startDate).format('DD MMM YYYY')
            )
        },
        size: 60
    }, {
        header: 'End Date',
        accessorKey: 'endDate',
        cell: ({row}) =>{
            return(
                dayjs(row.original.endDate).format('DD MMM YYYY')
            )
        },
        size: 60
    }, {
        header: 'Status',
        accessorKey: 'isActive',
        cell: ({row}) =>{
            const isActive = row.original.isActive;
            return(
                <StatusCell status={isActive}/>
            )
        },
        size: 60
    }, {
        header: 'Local Customer',
        accessorKey: 'isActive',
        cell: ({row}) =>{
            const isLocal = row.original.isLocal;
            return(
                isLocal ? 'True' : 'False'
            )
        },
        size: 60
    }, {
        header: 'Action',
        accessorKey: 'id',
        size: 60,
        cell: ({row}) =>{
            return(
                <AnchorSpan onClick={()=>{handleEditClick(row.original)}} key={row.id} style={{float: 'right', justifyContent: 'end', minWidth: '35px'}}>Edit</AnchorSpan>
            )
        },
    }];


    const handleEditClick = (row: country) => {
        setModelTitle('Edit MI Country');
        setCountryDeatils({...row, startDate: dayjs(row.startDate), endDate: dayjs(row.endDate)});
        setOpenModal(true);
    }

    const handleAddClick = () => {
        setCountriesList(props.getcountrylst());
        setModelTitle('Add  MI Country');
        setCountryDeatils({name: '', startDate: null, endDate: null, isActive: true, isLocal: false});
        setOpenModal(true);
    }

    const save = () => {
        const countryData = {...countryDeatils, startDate: dayjs(countryDeatils.startDate).format('YYYY-MM-DD'), endDate: dayjs(countryDeatils.endDate).format('YYYY-MM-DD')};
        postData(ApiUrls.addorupdatecountry, countryData).then((response) => {
            if(response.status == 200){
                getMiCountries("");
                setOpenModal(false);
                toast.success("Added Country to MI List");
            }
        }).catch((error) => {
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        });

    }

    const getMiCountries = (search: string) => {
        setIsLoading(true);
        postData(ApiUrls.miCountries, {"searchTerm": search}).then((response) => {
            setMiCountires(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            setApiErrorResponse({
                message : error.response.data.message,
                traceId : error.response.data.traceId
            });
        })
    }

    useEffect(() => {
        if(isOnLoad){
            setIsOnLoad(false);
            getMiCountries(searchText);
        }
    },[searchText]);


    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
          getMiCountries(searchText);
        }
    };


    return (
        <>
            <ContainerDiv>
                <Row>
					<Col size='65'>
						<Button onClick={()=>{handleAddClick()}}><Add/>Add MI Country</Button>
					</Col>
                    <Col size='35'>
                        <Row>
                        <Label bold style={{paddingRight:'4px'}} type={TextTypes.Label} htmlFor='search'>Search</Label>
                        <TextInput size="medium" onChange={(event)=>{setSearchText(event.target.value);}} suffix={{node: <Search />}} placeholder="Search by Country Name" id='search'  onKeyDown={handleKeyDown}/>
                        </Row>
					</Col>
                </Row>
            </ContainerDiv>
            
            <Row>
                <Col size="100">
                    { !isLoading && <BaseTable data={miCountries} columns={columns} noFooter/>}
                    { isLoading && <Loader/>}      
                </Col>
            </Row>

            <Modal  open={openModal} onClose={() => {
                    setOpenModal(false);
                }} 

                actions={[{
                    label: 'Save',
                    action: () => {
                        save()
                    }
                }]}
                title={modelTitle}
                
                >
                <>
                    <FormField id="country" label="Country">
                        <Select value={countryDeatils.name} onChange={(value) => {setCountryDeatils({...countryDeatils, name: value}) }} >
                            {countriesList.map((country)=>(
                                <Option value={country.countryName} key={country.countryName}>{country.countryName}</Option>
                            ))}
                        </Select>
                    </FormField>

                    <FormField id="startDate" label="Start Date">
                        <SingleDatePicker showToday={false}  value={countryDeatils.startDate} onChange={(e) => {setCountryDeatils({ ...countryDeatils, startDate : e})}} format='DD MMM YYYY' size='small' />
                    </FormField>

                    <FormField id="endDate" label="End Date">
                        <SingleDatePicker showToday={false}  value={countryDeatils.endDate} onChange={(e) => {setCountryDeatils({ ...countryDeatils, endDate : e})}} format='DD MMM YYYY' size='small'/>
                    </FormField>

                    <div style={{marginBottom:'10px'}}>
                    <Row>
                        <Col size="90"><Label bold className='statusLabel'>Status</Label></Col>
                        <Col size="10"><Toggle onChange={ (e) => {setCountryDeatils({ ...countryDeatils, isActive : e})}} checked={countryDeatils.isActive} /></Col>
                    </Row>
                    </div>
                    
                    <Row>
                        <Col size="90"><Label bold className='LocalCustomerLabel'>Local Customer</Label></Col>
                        <Col size="10"><Toggle onChange={ (e) => {setCountryDeatils({ ...countryDeatils, isLocal : e})}} checked={countryDeatils.isLocal} /></Col>
                    </Row>
                </>
            </Modal>

            <ResponseErrorModal errorDetails={apiErrorResponse} isOpen={apiErrorResponse ? true : false} onModalClose={()=>{setApiErrorResponse(null)}}></ResponseErrorModal>
        </>
    )
}
export default Country;